import Cookies from 'js-cookie'

// const TokenKey = 'We-Token'

export function getCookies(key) {
  return Cookies.get(key)
}

export function setCookies(key,token) {
  return Cookies.set(key, token)
}

export function removeCookies(key) {
  return Cookies.remove(key)
}
